<div class="card" *ngIf="typeFile">
  <p class="attach-order-files__supported-formats">
    <span>{{ 'messages.supportedFileFormats' | translate }}</span>
    <strong *ngIf="typeFile.accept === '*.*'; else supportedFileFormats">
      {{ 'messages.allFileFormats' | translate }}
    </strong>
    <ng-template #supportedFileFormats>
      <strong>{{ typeFile.accept }}</strong>
    </ng-template>
  </p>
  <p-fileupload
    [showUploadButton]="false"
    [chooseLabel]="'general.browseFiles' | translate"
    [showCancelButton]="false"
    [multiple]="typeFile.multiple"
    [accept]="fileUploadAccept"
    [maxFileSize]="typeFile.maxMegabytes * 1024 * 1024"
    [invalidFileTypeMessageSummary]="''"
    [invalidFileTypeMessageDetail]="'messages.invalidFileFormat' | translate: { fileTypes: typeFile.accept }"
    [disabled]="isSelectingFile"
    (onSelect)="onSelectFile($event)"
    mode="advanced"
  >
    <ng-template #empty>
      <div>Drag and drop files to here to upload({{ typeFile.accept }})</div>
    </ng-template>
    <!--        <ng-template #header>-->
    <!--            <div class="flex"></div>-->
    <!--        </ng-template>-->
    <ng-template #content>
      <ul class="attach-order-files__list" *ngIf="fileModels?.length">
        <li *ngFor="let file of fileModels">
          <p-message severity="secondary" [closable]="false">
            <div class="attach-order-files__item__info">
              <span>{{ file.name }}</span>
              <span class="attach-order-files__item__size">
                <small>{{ file.size | prettyBytes }}</small>
              </span>
            </div>

            <div class="attach-order-files__item__close">
              <p-button
                [disabled]="file.uploading || file.removing"
                [text]="true"
                [loading]="file.removing"
                severity="secondary"
                icon="pi pi-times-circle"
                (onClick)="onRemoveFile(file)"
              />
            </div>
          </p-message>
          <p-progress-bar *ngIf="file.uploading && file.progress != null" [value]="file.progress" [showValue]="false" />
        </li>
      </ul>
    </ng-template>

    <ng-template #file>
      <div style="display: none"></div>
    </ng-template>
  </p-fileupload>
  <p-message
    *ngIf="(hasInvalidFileFormat || hasUnsafeFileFormat) && fileUploadAccept.length === 0"
    severity="error"
    variant="simple"
    size="small"
  >
    {{
      (hasUnsafeFileFormat ? 'messages.unsafeFileFormat' : 'messages.invalidFileFormat')
        | translate: { fileTypes: typeFile.accept }
    }}
  </p-message>
</div>
